// extracted by mini-css-extract-plugin
module.exports = {"registerFormSection":"RegisterFormSection_registerFormSection__EdA5B"};